// ============================================================================
// FILE: src/modules/ticket/services/performanceDashboardService.js
// PURPOSE:
//   API service for Ticket Performance Dashboard
// ============================================================================

import axiosClient from "../../../api/axiosClient";

// ---------------------------------------------------------------------------
// DEBUG helper (temporary but safe)
// ---------------------------------------------------------------------------
function logParams(label, params) {
  console.log(`[PerformanceDashboardService] ${label} params →`, params);
}

// ---------------------------------------------------------------------------
// Tenant-level performance
// ---------------------------------------------------------------------------
export async function getTenantPerformance(params = {}) {
  logParams("Tenant", params);

  return axiosClient
    .get("/ticket-management/performance/tenant", {
      params, // ✅ THIS IS THE FIX
    })
    .then((res) => res.data);
}

// ---------------------------------------------------------------------------
// Location-level performance
// ---------------------------------------------------------------------------
export async function getLocationPerformance(params = {}) {
  logParams("Location", params);

  return axiosClient
    .get("/ticket-management/performance/location", {
      params, // ✅ THIS IS THE FIX
    })
    .then((res) => res.data);
}

// ---------------------------------------------------------------------------
// Executive-level performance
// ---------------------------------------------------------------------------
export async function getExecutivePerformance(params = {}) {
  logParams("Executive", params);

  return axiosClient
    .get("/ticket-management/performance/executive", {
      params, // ✅ THIS IS THE FIX
    })
    .then((res) => res.data);
}
